import { UserProfileState } from '@/redux/modal/UserProfile/userProfile.types';

export const USER_PROFILE_INITIAL_STATE: UserProfileState = {
  activeTab: 0,
};
